import { gqlScheduleInviteRequestStatus } from '@minecraft.graphql-types';
import { SelectOption } from '@minecraft.typings';
import { useTranslation } from '@blocs.i18n';
import { NOT_YET_SENT } from '../config';

export const useScheduleStatusOptions = (withNotYetSent = false): SelectOption[] => {
  const { t } = useTranslation();

  return [
    ...(withNotYetSent ? [{ value: NOT_YET_SENT, label: t('casting:project.requests.notYetSent') }] : []),
    { value: gqlScheduleInviteRequestStatus.PENDING, label: t('casting:project.requests.sentAndPending') },
    {
      value: gqlScheduleInviteRequestStatus.RESCHEDULE_REQUESTED,
      label: t('casting:project.requests.requestedReschedule'),
    },
    { value: gqlScheduleInviteRequestStatus.CONFIRMED, label: t('casting:project.requests.confirmed') },
    { value: gqlScheduleInviteRequestStatus.DECLINED, label: t('casting:project.requests.declined') },
  ];
};
